import { render, staticRenderFns } from "./FloatingPanel.vue?vue&type=template&id=0afb8252&scoped=true&"
import script from "./FloatingPanel.vue?vue&type=script&lang=ts&"
export * from "./FloatingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingPanel.vue?vue&type=style&index=0&id=0afb8252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb8252",
  null
  
)

export default component.exports